<div id="ricambio">
    <div *ngIf="macchinaSelezionata">
        <nav>
            <ul class="nav-wrapper"  *ngIf="!ricerca">
                <li><a mat-raised-button color="primary" [routerLink]="['/macchine']">{{'MY g&w'|translate}}</a></li><li *ngFor="let m of navigazione"><span>&raquo;</span><a mat-raised-button color="primary" [routerLink]="['/macchine',m.id]">{{m.nome}}</a></li><li *ngIf="macchinaSelezionata"><span>&raquo;</span><a  mat-raised-button color="accent">{{macchinaSelezionata.nome}}</a></li>
            </ul>
        </nav>
        <mat-card class="testata">
            <div class="img bgfix" [ngStyle]="{'background-image': 'url(' + macchinaSelezionata.img + ')'}">
            </div>
            <div *ngIf="macchinaSelezionata.imgsec" class="imgsec img bgfix" [ngStyle]="{'background-image': 'url(' + macchinaSelezionata.imgsec + ')'}">
            </div>
            <!-- img  src="{{ macchinaSelezionata.img}}" width="250px" height="250px" -->
            <h1>{{macchinaSelezionata.nome}}</h1>
            <mat-card-title>{{ macchinaSelezionata.descrizione}}</mat-card-title>
            <mat-card-subtitle><span>{{'Codice'|translate}}</span> {{ macchinaSelezionata.codice}}</mat-card-subtitle>
            <div class="bottoni">
                <a href="https://ghibli.ricambio.net/site/pagece5.wplus?ID_COUNT=ce_5_home&LN={{utente.lingua}}&CEPV=Ghibli002&CELN={{utente.lingua}}&CEME=2&CEOP=LOGOUTCE5&AUTOSTARTCEPV=1&CEURLGET_UID={{utente.uid}}&CEURLGET_usertype=g&CEURLGET_SessionID={{utente.sessionUID}}&UID={{utente.uid}}&SESSIONID={{utente.sessionUID}}&IDSCOD={{macchinaSelezionata.codice}}" target="_blank" mat-raised-button color="bottone" >{{'Ricambistica'|translate}}</a>
                <!-- button [routerLink]="['/documentazione', macchinaSelezionata.categoria.id, macchinaSelezionata.id]" mat-raised-button color="bottonebianco" >{{'Documentazione'|translate}}</button -->
            </div>
            <mat-card-content>
                <div class="ordina" *ngIf="utente && utente.carrello">
                    <div *ngIf="utente && utente.prezzi"><br>{{'Prezzo €'|translate}} {{ macchinaSelezionata.prezzo }}</div>
                    <div class="qta" *ngIf="utente && utente.qta">
                        <span>{{'Qta'|translate}} </span><input [(ngModel)]="qta" name="qta" type="number" min="0" step="1" size="2" /><button (click)="aggiungiMacchinaCarrello()" mat-raised-button color="accent" >{{'Aggiungi al carrello'|translate}}</button>
                    </div>
                </div>
                
                <div *ngIf="tavolaCorrente">
                    <button mat-raised-button [matMenuTriggerFor]="menu">{{tavolaCorrente.nome}}</button>

                    <mat-menu #menu="matMenu">
                        <button mat-menu-item *ngFor="let m of macchinaSelezionata.tavole"  (click)="scegliTavola(m)"> {{m.nome}} </button>
                    </mat-menu>
                </div>
            </mat-card-content>
        </mat-card>
        <div *ngIf="tavolaCorrente">
            <mat-card class="tavolaimg">
                <img class='zoom' id="ricambioImg"  attr.src="{{tavolaCorrente.img}}" onload="caricata(this.id);" attr.immagine="{{tavolaCorrente.img}}">
            </mat-card>
            <mat-card class="tavolaricambi">

                <h3 mat-subheader>Ricambi</h3>
                <table class="mat-data-table" cellpadding="0" cellspacing="0">
                    <thead>
                        <tr>
                            <th class="mat-data-table__cell--non-numeric">
                                <span>Posizione </span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>Codice </span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>Descrizione </span>
                            </th>
                            <th class=" mdl-data-table__cell--non-numeric">
                                <span>Qta </span>
                            </th>
                            <th class=" mdl-data-table__cell--non-numeric">
                                <span>Prezzo </span>
                            </th>
                            <th class=" mdl-data-table__cell--non-numeric">
                                <span>Ordina </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr grid-item  *ngFor="let r of tavolaCorrente.ricambi">
                            <td class="mdl-data-table__cell--non-numeric">
                                {{r.posizione}}
                            </td>
                            <td>{{r.codice}}</td>
                            <td>{{r.descrizione}}</td>
                            <td>{{r.qta}}</td>
                            <td class="right">{{r.prezzo}}</td>
                            <td><button mat-raised-button (click)="aggiungiCarrello(r)"><i class="material-icons">&#xE854;</i></button></td>
                        </tr>
                    </tbody>
                </table>


            </mat-card>
        </div>
        <div class="contenuti">


            <div class="ricambi-destra">
                <mat-card class="accessori-macchina">

                    <h3 mat-subheader>{{'Accessori optional'|translate}}</h3>
                    <div *ngIf="!macchinaSelezionata.optional || macchinaSelezionata.optional.length<1" class="risultati">
                        {{'Non ci sono optional'|translate}}
                </div>
                    <table  *ngIf="macchinaSelezionata.optional && macchinaSelezionata.optional.length>0" class="mat-data-table" cellpadding="0" cellspacing="0" width="100%">
                        <thead>
                            <tr>

                                <th class="mdl-data-table__cell--non-numeric">
                                    <span>{{'Codice'|translate}} </span>
                                </th>
                                <th class="mdl-data-table__cell--non-numeric" width="70%">
                                    <span>{{'Descrizione'|translate}} </span> 
                                </th>
                                <th  *ngIf="utente && utente.prezzi" class=" mdl-data-table__cell--non-numeric right">
                                    <span style="white-space: nowrap;">{{'Prezzo €'|translate}} </span>
                                </th>
                                <th *ngIf="utente && utente.qta" class="number qta" width="50">
                                    <span>{{'Qta'|translate}}</span>
                                </th>
                                <th *ngIf="utente && utente.carrello" class=" mdl-data-table__cell--non-numeric">
                                    <span> </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr grid-item  *ngFor="let r of macchinaSelezionata.optional">
                                <td><a *ngIf="r.id>0" [routerLink]="['/accessorio', r.id]" class="nowrap">{{r.codice}}</a></td>
                                <td>{{r.descrizione}}</td>
                                <td *ngIf="utente && utente.prezzi" class="prezzo"><span *ngIf="r.id>0">{{r.prezzo}}</span></td>
                                <td *ngIf="utente && utente.qta" class="number qta"><input *ngIf="r.id>0" [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="0" step="1" size="2" /></td>
                                <td *ngIf=" utente && utente.carrello" ><a *ngIf="r.id>0" class="carrello" (click)="aggiungiCarrello(r)"><i class="material-icons">&#xE854;</i></a></td>
                            </tr>
                        </tbody>
                    </table>
                </mat-card>
                <mat-card class="accessori-macchina">
                    <h3 mat-subheader>{{'Accessori in dotazione'|translate}}</h3>
                    <div *ngIf="!macchinaSelezionata.accessori || macchinaSelezionata.accessori.length<1" class="risultati">
                        {{'Non ci sono accessori in dotazione'|translate}}
                </div>
                    <table  *ngIf="macchinaSelezionata.accessori && macchinaSelezionata.accessori.length>0" class="mat-data-table" cellpadding="0" cellspacing="0" width="100%">
                        <thead>
                            <tr>

                                <th class="mdl-data-table__cell--non-numeric">
                                    <span>{{'Codice'|translate}} </span>
                                </th>
                                <th class="mdl-data-table__cell--non-numeric" width="70%">
                                    <span>{{'Descrizione'|translate}} </span> 
                                </th>
                                <th *ngIf="utente && utente.prezzi" class=" mdl-data-table__cell--non-numeric right">
                                    <span style="white-space: nowrap;">{{'Prezzo €'|translate}} </span>
                                </th>
                                 <th *ngIf="utente && utente.qta" class="number qta" width="50">
                                    <span>{{'Qta'|translate}}</span>
                                </th>
                                <th *ngIf="utente && utente.carrello" class=" mdl-data-table__cell--non-numeric">
                                    <span> </span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr grid-item  *ngFor="let r of macchinaSelezionata.accessori">
                                <td><a *ngIf="r.id>0" [routerLink]="['/accessorio', r.id]" class="nowrap">{{r.codice}}</a></td>
                                <td>{{r.descrizione}}</td>
                                <td *ngIf="utente && utente.prezzi" class="prezzo"><span *ngIf="r.id>0">{{r.prezzo}}</span></td>
                                <td *ngIf="utente && utente.qta" class="number qta"><input *ngIf="r.id>0" [(ngModel)]="r.qta" name="qta_{{r.id}}" type="number" min="0" step="1" size="2" /></td>
                                <td *ngIf="utente && utente.carrello"><a *ngIf="r.id>0" class="carrello" (click)="aggiungiCarrello(r)"><i class="material-icons">&#xE854;</i></a></td>
                            </tr>
                        </tbody>
                    </table>
                </mat-card>
            </div>
            <div class="ricambi-sinistra">
                <mat-card class="accessori-macchina">

                    <h3 mat-subheader>{{'Documentazione'|translate}}</h3>
                    <div *ngIf="!macchinaSelezionata.documenti || macchinaSelezionata.documenti.length<1" class="risultati">
                        {{'Nessun documento trovato'|translate}}
                </div>
                <table *ngIf="macchinaSelezionata.documenti && macchinaSelezionata.documenti.length>0" class="mat-data-table" cellpadding="0" cellspacing="0" width="100%" >
                    <thead>
                        <tr>

                            <th class="mdl-data-table__cell--non-numeric" width="80%">
                                <span>{{'Tipo documento'|translate}} </span>
                            </th>
                            <th class=" right mdl-data-table__cell--non-numeric">
                                <span>Dim.</span>
                            </th><th></th>

                        </tr>
                    </thead>
                    <tbody>
                        <tr grid-item *ngFor="let f of macchinaSelezionata.documenti">
                            <td><a target="_blank" href="{{f.url}}" class="nowrap">{{f.descrizione}}</a></td>
                            <td class="prezzo">{{f.size}}</td>
                            <td><a target="_blank" href="{{f.url}}"><i class="material-icons">&#xE884;</i></a></td>
                        </tr>
                    </tbody>
                </table>
            </mat-card>
            <mat-card class="matricole-macchina">

                <h3 mat-subheader>{{'Macchine acquistate'|translate}}</h3>
                <div *ngIf="!macchinaSelezionata.matricole || macchinaSelezionata.matricole.length<1" class="risultati">
                        {{'Nessun macchina in garanzia'|translate}}
                </div>
                <table class="mat-data-table" cellpadding="0" cellspacing="0" width="100%" *ngIf="macchinaSelezionata.matricole && macchinaSelezionata.matricole.length>0">
                    <thead>
                        <tr>

                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Matricola'|translate}} </span>
                            </th>
                            <th class="mdl-data-table__cell--non-numeric">
                                <span>{{'Data acquisto'|translate}} </span>
                            </th>
                            <th class=" mdl-data-table__cell--non-numeric">
                                <span>{{'Richiesta di garanzia'|translate}} </span>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr grid-item  *ngFor="let r of macchinaSelezionata.matricole">
                            <td class="nowrap">{{r.codice}}</td>
                            <td>{{r.data}}</td>
                            <td><a *ngIf="r.garanzia" [routerLink]="['/richiestaGaranzia', r.id]"><i class="material-icons">&#xE254;</i></a></td>
                        </tr>
                    </tbody>
                </table>


            </mat-card>
        </div>
    </div>
</div>
</div>


// WEBPACK FOOTER //
// ./src/app/tws-macchina/tws-macchina.component.html